import {
  ArrowDownOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Radio,
  Row,
  Select,
  message,
} from 'antd';
import { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  fetchCustomerTypeDropdown,
  fetchCustomerTypeList,
  resetCurrentCustomerTypePage,
  resetCustomerTypeList,
} from '../../slices/customer-type';
import { createCustomer } from '../../slices/customer';
import { fetchUserList, resetUserList } from '../../slices/user';

const { Option } = Select;
const { Panel } = Collapse;

function AddNewCustomer() {
  const [form] = Form.useForm();
  const [selectedOption, setSelectedOption] = useState('INDIAN');
  const [activePanels, setActivePanels] = useState(['8']);

  const {
    list: userNameList,
  } = useSelector(state => state.user);

  const filteredUserList = userNameList.filter(user =>
    user.groups && user.groups.some(role => role === 'Sm Manager' || role === 'Sales Executive')
  );

  const [searchCustomerType, setSearchCustomerType] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();



  const {
    list: customerTypeList,
    loading: customerTypeLoading,
    currentpage: customerTypeCurrentPage,
    hasMore: customerTypeHasMore,
  } = useSelector(state => state.customerType);


  const handleCopyofficeAddressChange = e => {
    if (e.target.checked) {
      form.setFieldsValue({
        factory_address_shop: form.getFieldValue('office_address_shop'),
        factory_address_area: form.getFieldValue('office_address_area'),
        factory_address_landmark: form.getFieldValue('office_address_landmark'),
        factory_address_pin_code: form.getFieldValue('office_address_pin_code'),
        factory_address_city: form.getFieldValue('office_address_city'),
        factory_address_state: form.getFieldValue('office_address_state'),
        factory_address_country: form.getFieldValue('office_address_country'),
      });
    } else {
      form.setFieldsValue({
        factory_address_shop: '',
        factory_address_area: '',
        factory_address_landmark: '',
        factory_address_pin_code: '',
        factory_address_city: '',
        factory_address_state: '',
        factory_address_country: '',
      });
    }
  };

  const handleSearchCustomerTypeList = value => {
    setSearchCustomerType(value);
    if (value) {
      setSearchCustomerType(value);
      dispatch(resetCustomerTypeList());
      dispatch(fetchCustomerTypeList({ page: 1, pagesize: 100, search: value }));
      dispatch(fetchCustomerTypeDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchCustomerType('');
      dispatch(resetCustomerTypeList());
      dispatch(resetCurrentCustomerTypePage());
      dispatch(fetchCustomerTypeList({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeCustomerTypeList = value => {
    setSearchCustomerType(value);
  };

  const onScrollCustomerType = async event => {
    const target = event.target;
    if (
      !customerTypeLoading &&
      customerTypeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchCustomerTypeList({ page: customerTypeCurrentPage, pagesize: 10 }),
      );
    }
  };

  useEffect(() => {
    dispatch(resetCustomerTypeList());
    dispatch(resetUserList());
    dispatch(fetchCustomerTypeDropdown({ page: 1, pagesize: 100 }));
    dispatch(fetchUserList({ page: 1, pagesize: 1000 }));
  }, [dispatch]);

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedData = {
      ...values,
      sales_executive: values.sales_executive?.value, 
      sales_executive_assistant: values.sales_executive_assistant?.value,
      business_type: values.business_type || 'INDIAN',
    };
    dispatch(createCustomer({ formattedData }))
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success('Customer Created Successfully!');
          navigate('/customer-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };


  const onFinishFailed = errorInfo => {
    const errorFields = errorInfo.errorFields.map(field => field.name[0]);

    const panelMap = {
      gstin_number: '8',
      gst_type: '8',
      pan_number: '8',
      customer_name: '1',
      trade_name: '1',
      code: '1',
      person_name: '1',
      designation: '1',
      phone_number: '1',
      fax_number: '1',
      email: '1',
      website: '1',
      customer_type: '1',
      delivery_days: '1',
      customer_section_no: '1',
      office_address_shop: '6',
      office_address_area: '6',
      office_address_landmark: '6',
      office_address_pin_code: '6',
      office_address_city: '6',
      office_address_state: '6',
      office_address_country: '6',
      factory_address_shop: '6',
      factory_address_area: '6',
      factory_address_landmark: '6',
      factory_address_pin_code: '6',
      factory_address_city: '6',
      factory_address_state: '6',
      factory_address_country: '6',
      customer_contact_persons: '2',
      customer_banking_details: '3'
    };

    const panelsToOpen = [...new Set(errorFields.map(field => panelMap[field]).filter(Boolean))];

    // Update active panels
    setActivePanels(panelsToOpen);
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Add New Customer</h2>
          <div className="bredcrumbwrp">
            <Link to="/customer-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/customer-list">Customers</Link> },
                { title: 'Add New Customer' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          initialValues={{
            business_type: 'INDIAN',
            customer_contact_persons: [
              {
                contact_person_name: '',
                contact_person_designation: '',
                contact_person_mobile_number: '',
                contact_person_email: '',
              },
            ],
            customer_banking_details: [
              {
                bank_name: '',
                bank_account_number: '',
                bank_ifsc_code: '',
                bank_branch_address: '',
                bank_ad_code: '',
                beneficiary_swift_code: '',
              },
            ],
          }}
        >


          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Tax Information" key="8" forceRender={true}>
              <Row>
                <Form.Item style={{ marginBottom: '10px' }}>
                  <Radio.Group
                    value={selectedOption}
                    name="business_type"
                    onChange={e => {
                      setSelectedOption(e.target.value);
                      form.setFieldsValue({ business_type: e.target.value });
                    }}
                  >
                    <Radio value="INDIAN">INDIAN</Radio>
                    <Radio value="OVERSEAS">OVERSEAS</Radio>
                  </Radio.Group>
                </Form.Item>
              </Row>
              <Row gutter={16}>
                {selectedOption === 'INDIAN' && (
                  <>
                    <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                      <Form.Item
                        label="GSTIN Number"
                        name="gstin_number"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter GSTIN number',
                          },
                          {
                            pattern:
                              /^((0[1-9])|([1-9])|([1-2][0-9])|(3[0-5]))[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,
                            message: 'Please enter a valid GSTIN number',
                          },
                        ]}
                      >
                        <div className="verifywrap">
                          <Input placeholder="Enter Gstin Number" />
                        </div>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                      <Form.Item label="GST Type" name="gst_type">
                        <AutoOpenSelect
                          placeholder="Select GST Type"
                          showSearch={true}
                          allowClear
                          onSearch={value => {
                          }}
                          filterOption={(input, option) =>
                            option?.children
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value="regular">Regular</Option>
                          <Option value="composition">Composition</Option>
                          <Option value="consumer">Consumer</Option>
                          <Option value="unregistered">Unregistered</Option>
                        </AutoOpenSelect>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                      <Form.Item
                        label="Pan Number"
                        name="pan_number"
                        rules={[
                          { required: true, message: 'Please enter PAN number' },
                          {
                            pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                            message: 'Please enter a valid PAN number',
                          },
                        ]}
                      >
                        <div className="verifywrap">
                          <Input placeholder="Enter Pan Number" />
                        </div>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                      <Form.Item
                        label="Udyam No / MSME"
                        name="udyam_no"
                        rules={[
                          {
                            pattern: /^[A-Z0-9-]+$/,
                            message:
                              'Only uppercase letters (A-Z), numbers (0-9), and hyphens (-) are allowed.',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Udyam No / MSME" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                      <Form.Item
                        label="Applicable GST"
                        name="applicable_gst"
                        rules={[
                          { required: true, message: 'Please select a GST' },
                        ]}
                      >
                        <AutoOpenSelect
                          placeholder="Select Applicable GST"
                          showSearch={true}
                          allowClear
                          onSearch={value => {
                          }}
                          filterOption={(input, option) =>
                            option?.children
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value="igst">IGST</Option>
                          <Option value="sgst_cgst">SGST_CGST</Option>
                        </AutoOpenSelect>
                      </Form.Item>
                    </Col>
                  </>
                )}
                {selectedOption === 'OVERSEAS' && (
                  <>
                    <Col xs={24} lg={4}>
                      <Form.Item
                        label="Import Export Code"
                        name="import_export_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid import export code',
                          },
                          {
                            pattern: /^[a-zA-Z0-9]+$/,
                            message:
                              'Please enter a string with only letters and numbers',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter import export code"
                          maxLength={12}
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              import_export_code: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={4}>
                      <Form.Item
                        label="Beneficiary Agent Code"
                        name="beneficiary_agent_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid beneficiary agent code',
                          },
                          {
                            pattern: /^[a-zA-Z0-9]+$/,
                            message:
                              'Please enter a string with only letters and numbers',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter beneficiary agent code"
                          maxLength={16}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </Panel>
          </Collapse>
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="General Information" key="1" forceRender={true}>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item
                    label="Customer Name"
                    name="customer_name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid customer name',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Customer Name"
                      onChange={e => {
                        const input = e.target;
                        const value = input.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ customer_name: formattedValue });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Trade Name"
                    name="trade_name"
                    rules={
                      [
                      ]
                    }
                  >
                    <Input
                      placeholder="Enter Trade Name"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          trade_name: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Code"
                    name="code"
                  >
                    <Input
                      placeholder="Enter Code"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          code: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item
                    name="person_name"
                    label="Person Name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid name',
                      },
                      {
                        pattern: /^[a-zA-Z\s]+$/,
                        message: 'Please enter valid name',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Name"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          person_name: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    name="designation"
                    label="Designation"
                    rules={[
                      {
                        pattern: /^[A-Za-z\s\-.']+$/,
                        message: 'Please enter valid designation',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Designation"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          designation: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item
                    label="Phone Number"
                    name="phone_number"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter phone number"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Fax Number"
                    name="fax_number"
                    rules={[
                      {
                        pattern:
                          /^\+?[0-9\s\-()]{7,20}$/,
                        //    /^\+?(\d{1,3})?[\s\-()]?\d+[\s\-()]?\d+[\s\-()]?\d+$/,
                        message: 'Enter a valid fax number, e.g., (+1 555 123-4567)',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Fax Number"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          fax_number: formattedValue,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        type: 'email',
                        message: 'Please enter a valid email address',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Email" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={4}>
                  <Form.Item
                    label="Web"
                    name="website"
                  >
                    <Input
                      placeholder="Enter Web"
                      onChange={e => {
                        const value = e.target.value;
                        form.setFieldsValue({
                          website: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                  <Form.Item
                    label="Customer Type"
                    name="customer_type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a customer type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Customer Type"
                      style={{ width: '100%' }}
                      loading={customerTypeLoading}
                      onPopupScroll={onScrollCustomerType}
                      value={searchCustomerType}
                      onChange={handleChangeCustomerTypeList}
                      onSearch={handleSearchCustomerTypeList}
                      allowClear
                      showSearch={true}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      notFoundContent={
                        customerTypeLoading ? 'Loading...' : 'No options'
                      }
                      dropdownRender={menu => (
                        <>
                          {menu}
                        </>
                      )}
                    >
                      {[
                        ...new Map(
                          customerTypeList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                          {el.name}
                        </Option>
                      ))}
                      {customerTypeLoading && <Option>Loading...</Option>}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={7} lg={3}>
                  <Form.Item
                    label="Delivery Days"
                    name="delivery_days"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid delivery days',
                      },
                      {
                        pattern: /^[0-9]{1,3}$/,
                        message: 'Only digits up to 3 characters are allowed',
                      },
                    ]}
                  >
                    <Input placeholder="Delivery Days" maxLength={3} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={10} md={7} lg={4}>
                  <Form.Item
                    label="Customer Profile No"
                    name="customer_section_no"
                  >
                    <Input
                      placeholder="Enter Customer Profile No"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({
                          customer_section_no: formattedValue,
                        }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={10} md={7} lg={4}>
                  <Form.Item
                    label="Sales Executive"
                    name="sales_executive"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a sales executive',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Sales Executive"
                      style={{ width: '100%' }}
                      labelInValue
                      showSearch={true}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownRender={menu => <>{menu}</>}
                    >
                      {[
                        ...new Map(
                          filteredUserList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {`${el.first_name} ${el.last_name}`}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={10} md={7} lg={4}>
                  <Form.Item
                    label="Sales Executive Assistant"
                    name="sales_executive_assistant"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a sales executive assistant  ',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Select Sales Executive Assistant"
                      style={{ width: '100%' }}
                      labelInValue
                      showSearch={true}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownRender={menu => <>{menu}</>}
                    >
                      {[
                        ...new Map(
                          filteredUserList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {`${el.first_name} ${el.last_name}`}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Address Information" key="6" forceRender={true}>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <h3 className="adrstitle">Office Address</h3>
                  <Row gutter={16}>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Shop No, Building, Apartment"
                        name="office_address_shop"
                        rules={[
                          {
                            required: true,
                            message:
                              'Please enter valid shop no, building, apartment',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter shop no, building, apartment"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_shop: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Area, Street"
                        name="office_address_area"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid area, street',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter area, street"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_area: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Landmark"
                        name="office_address_landmark"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid landmark',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Landmark"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_landmark: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Pin Code"
                        name="office_address_pin_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid pincode',
                          },
                          {

                            message: 'Please enter a valid  pin code',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Pincode" maxLength={20} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="City"
                        name="office_address_city"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid city',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid city name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter City"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_city: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="State"
                        name="office_address_state"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid state',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid state name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter State"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_state: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Country"
                        name="office_address_country"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid country',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid country name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Country"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              office_address_country: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24} sm={12}>
                  <div className="colsubtitle">
                    <h3 className="adrstitle">
                      Factory Address
                      <Checkbox
                        className="copytxt"
                        onChange={handleCopyofficeAddressChange}
                      >
                        ( <ArrowDownOutlined /> Copy office address )
                      </Checkbox>
                    </h3>
                  </div>
                  <Row gutter={16}>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Shop No, Building, Apartment"
                        name="factory_address_shop"
                        rules={[
                          {
                            required: true,
                            message:
                              'Please enter valid shop no, building, apartment',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter shop no, building, apartment"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_shop: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Area, Street"
                        name="factory_address_area"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid area, street',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter area, street"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_area: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Landmark"
                        name="factory_address_landmark"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid landmark',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Landmark"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_landmark: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Pin Code"
                        name="factory_address_pin_code"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid pincode',
                          },
                          {

                            message: 'Please enter a valid pin code',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Pincode" maxLength={20} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="City"
                        name="factory_address_city"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid city',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid city name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter City"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_city: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="State"
                        name="factory_address_state"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid state',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid state name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter State"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_state: formattedValue,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Country"
                        name="factory_address_country"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid country',
                          },
                          {
                            pattern: /^[a-zA-Z\s]+$/,
                            message: 'Please enter valid country name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Country"
                          onChange={e => {
                            const value = e.target.value;
                            const formattedValue = value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());
                            form.setFieldsValue({
                              factory_address_country: formattedValue,
                            }); // Update Form state
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Contact Persons" key="2" forceRender={true}>
              <Form.List name="customer_contact_persons">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row
                        className="rowItem mx-0"
                        gutter={[24, 24]}
                        align="middle"
                        key={key}
                        wrap={false}
                      >
                        <Col flex="auto">
                          <Row gutter={16}>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'contact_person_name']}
                                label="Name"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid name',
                                  },
                                  {
                                    pattern: /^[a-zA-Z\s]+$/,
                                    message: 'Please enter valid name',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Name"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      [
                                        'customer_contact_persons',
                                        name,
                                        'contact_person_name',
                                      ],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'contact_person_designation']}
                                label="Designation"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid designation',
                                  },
                                  {
                                    pattern: /^[a-zA-Z\s]+$/,
                                    message: 'Please enter valid designation',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Designation"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      [
                                        'customer_contact_persons',
                                        name,
                                        'contact_person_designation',
                                      ],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'contact_person_mobile_number']}
                                label="Mobile Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please input your phone number!',
                                  },
                                ]}
                              >
                                <PhoneInput
                                  country="in"
                                  enableSearch
                                  placeholder="Enter phone number"
                                  onChange={value =>
                                    form.setFieldValue(
                                      [
                                        'customer_contact_persons',
                                        name,
                                        'contact_person_mobile_number',
                                      ],
                                      value,
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} xl={6}>
                              <Form.Item
                                {...restField}
                                name={[name, 'contact_person_email']}
                                label="Email"
                                rules={[
                                  {
                                    type: 'email',
                                    message:
                                      'Please enter a valid email address',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Email" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} xl={6}>
                              <Form.Item>
                                <div
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '25px',
                                    marginLeft: '39px',
                                  }}
                                >
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      if (fields.length < 15) {
                                        add();
                                      } else {
                                        message.error(
                                          'You can only add up to 15 records.',
                                        );
                                      }
                                    }}
                                    icon={<PlusOutlined />}
                                  >
                                    Add Contact Person
                                  </Button>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>

                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '18px',
                                marginLeft: '-29px',
                              }}
                            />
                          )}
                        </div>
                      </Row>
                    ))}
                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Banking Details" key="3" forceRender={true}>
              <Form.List name="customer_banking_details">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row gutter={16} key={key} wrap={false}>
                        <Col flex="auto">
                          <Row gutter={16}>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                label="Bank Name"
                                {...restField}
                                name={[name, 'bank_name']}
                                rules={[
                                  {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: 'Please enter valid bank name',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Bank Name"
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={3}>
                              <Form.Item
                                label="Account Number"
                                {...restField}
                                name={[name, 'bank_account_number']}
                                rules={[
                                  {
                                    pattern: /^[0-9]{9,27}$/,
                                    message:
                                      'Bank account number must be between 9 and 27 digits',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Account No." />
                              </Form.Item>
                            </Col>
                            <Form.Item
                              label="IFSC Code"
                              {...restField}
                              name={[name, 'bank_ifsc_code']}
                              normalize={value => (value || '').toUpperCase()}
                              rules={[
                                {
                                  required: false,
                                  pattern: /^(?:[0-9]+|[A-Za-z]+|[A-Za-z0-9]+)$/,
                                  message: 'Only enter numbers and capital letters',
                                },
                              ]}
                            >
                              <Input placeholder="Enter IFSC Code" />
                            </Form.Item>
                            <Col xs={24} md={4}>
                              <Form.Item
                                label="Branch Address"
                                {...restField}
                                name={[name, 'bank_branch_address']}
                              >
                                <Input
                                  rows={2}
                                  placeholder="Enter Bank Branch Address"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toLowerCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      [
                                        'customer_banking_details',
                                        name,
                                        'bank_branch_address',
                                      ],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={3}>
                              <Form.Item
                                label="Swift Code"
                                {...restField}
                                name={[name, 'beneficiary_swift_code']}
                                rules={[
                                  {
                                    pattern:
                                      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/,
                                    message:
                                      'Invalid SWIFT code. eg. (HDFCINBBXXX)',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Swift Code"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toUpperCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      [
                                        'customer_banking_details',
                                        name,
                                        'beneficiary_swift_code',
                                      ],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={3}>
                              <Form.Item
                                label="AD Code"
                                {...restField}
                                name={[name, 'bank_ad_code']}
                                rules={[
                                  {
                                    pattern: /^[A-Za-z0-9\s-]{6,10}$/,
                                    message:
                                      'Bank AD Code should be 6 to 10 characters long and can include letters, numbers, spaces, and hyphens.',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter AD Code"
                                  onChange={e => {
                                    const value = e.target.value;
                                    const formattedValue = value
                                      .toUpperCase()
                                      .replace(/\b\w/g, char =>
                                        char.toUpperCase(),
                                      );
                                    form.setFieldValue(
                                      [
                                        'customer_banking_details',
                                        name,
                                        'bank_ad_code',
                                      ],
                                      formattedValue,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={3}>
                              <Form.Item>
                                <div
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '25px',
                                  }}
                                >
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      if (fields.length < 15) {
                                        add();
                                      } else {
                                        message.error(
                                          'You can only add up to 15 records.',
                                        );
                                      }
                                    }}
                                    icon={<PlusOutlined />}
                                  >
                                    Add Bank Details
                                  </Button>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <div className="">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '27px',
                                marginLeft: '-59px',
                              }}
                            />
                          )}
                        </div>
                      </Row>
                    ))}
                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>

          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={btnLoading}
              icon={<PlusOutlined />}
            >
              Add Customer
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default AddNewCustomer;
